import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { ConvertEvent, Event, ApiEvent } from '@common/models';
import { TransformingDataService } from '@common/entities/data-service';

@Injectable()
export class PlEventDataService extends TransformingDataService<
  Event,
  ApiEvent
> {
  constructor(
    http: HttpClient,
    httpUrlGenerator: HttpUrlGenerator,
    config?: DefaultDataServiceConfig
  ) {
    super(
      'Event',
      http,
      httpUrlGenerator,
      ConvertEvent.fromApi,
      ConvertEvent.toApi,
      config
    );
  }
}
